// extracted by mini-css-extract-plugin
export default {"SignContainer":"Register_SignContainer__qXLM+","Sign":"Register_Sign__oCicL","SignForm":"Register_SignForm__nEV+2","sup":"Register_sup__T7YF5"};